<agpr-take-over-panel
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [showFooter]="false"
    (visibleChange)="closeDialog($event)"
    [responsiveWidth]="true"
    [minPanelWidth]="minPanelWidth"
    [maxPanelWidth]="maxPanelWidth"
    [noScroll]="true"
    [noPadding]="true"
>
    <ng-template #noScrollContent>
        <div class="agpr-aiHelper">
            <div class="agpr-aiHelper-header">
                <div class="agpr-aiHelper-headerLeft">
                    <span class="agpr-aiHelper-headerIcon fa-kit-duotone fa-agpr-ai-generic" aria-hidden="true"></span>
                    <h2>{{ 'Common.dialog.aiHelper.heading' | localize }}</h2>
                </div>
                <div class="agpr-aiHelper-headerRight">
                    <span class="agpr-aiHelper-headerRight-asterisk">*</span>
                    <span>{{ 'Common.dialog.aiHelper.requiredFields' | localize }}</span>
                </div>
            </div>
            <div class="agpr-aiHelper-bodyWrapper">
                <div class="agpr-aiHelper-bodyForm">
                    <agpr-scroll-panel class="agpr-aiHelper-bodyFormScroll">
                        <div class="agpr-aiHelper-bodyFormScroll-container">
                            <agpr-ai-setting-form
                                [(ngModel)]="aiSettings"
                                [allowCustomOptions]="true"
                                [showTargetAudienceField]="true"
                                [showPurposeField]="true"
                                (ngModelChange)="validateAiSettings()"
                                (aiQuickTip)="showQuickTip($event)"
                            ></agpr-ai-setting-form>
                        </div>
                    </agpr-scroll-panel>
                    <agpr-action-bar>
                        <ng-template #left>
                            <agpr-button
                                label="Core.button.cancel"
                                (click)="hideSlideOverlay = true;"
                                [style]="buttonEnum.secondary"
                            >
                            </agpr-button>
                        </ng-template>
                        <ng-template #right>
                            <agpr-button
                                [disabled]="(generatedContent.length && !hasGenerated) || !hasKeyMessage || !doneStreaming"
                                [label]="hasGenerated ? 'Common.dialog.aiHelper.regenerateButton' : 'Common.dialog.aiHelper.generateButton'"
                                [style]="hasGenerated ? buttonEnum.primaryB : buttonEnum.primary"
                                (click)="generate()"
                            >
                            </agpr-button>
                        </ng-template>
                    </agpr-action-bar>
                </div>
                <div class="agpr-aiHelper-bodyContent">
                    <div class="agpr-aiHelper-bodyContentGroup">
                        <div
                            class="agpr-aiHelper-bodyContentGroup-container"
                            *ngIf="!generatedContent.length"
                        >
                            <div
                                #quickTipContainer
                                id="open-ai-quickTip-container"
                                class="agpr-aiHelper-quickTip-container"
                            >
                                <div
                                    class="agpr-aiHelper-quickTip-header"
                                >
                                    <span
                                        class="agpr-aiHelper-quickTip-header-icon agpr-i-light-bulb"
                                        aria-hidden="true"
                                    ></span>
                                    <h2> {{ 'Common.dialog.aiHelper.quickTip.header' | localize }}</h2>
                                    <div class="agpr-aiHelper-quickTip-title">
                                        {{ quickTipInfo.header | localize }}
                                    </div>
                                </div>
                                <ul
                                    *ngIf="quickTipInfo.hints.length"
                                >
                                    <li
                                        *ngFor="let quickTip of quickTipInfo.hints"
                                    >{{ quickTip | localize }}</li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="agpr-aiHelper-generatedContent-headerContainer"
                            *ngIf="generatedContent.length"
                        >
                            <span class="agpr-aiHelper-generatedContent-header-icon fa-kit-duotone fa-agpr-ai"></span>
                            <h2 class="agpr-aiHelper-generatedContent-header">
                                {{ 'Common.dialog.aiHelper.generatedContent.header' | localize }}
                            </h2>
                        </div>
                        <agpr-scroll-panel
                            [agprLoading]="loading"
                        >
                            <div
                                class="agpr-aiHelper-bodyContentGenerated"
                            >
                                {{generatedContent}}
                            </div>
                        </agpr-scroll-panel>

                    </div>
                    <div
                        *ngIf="hasGenerated"
                        class="agpr-aiHelper-disclaimerContainer"
                    >
                        <agpr-ai-disclaimer
                            [disabled]="loading || !doneStreaming"
                            (apply)="apply()"
                        >
                        </agpr-ai-disclaimer>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</agpr-take-over-panel>
